module.exports = __webpack_public_path__ + "static/img/birthday.d69a8ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/birthday.png
// module id = ixUm
// module chunks = 1